import React, { useState } from 'react';
import type { CollaborationStartTarget } from './collaborationRouteApi';

interface CollaborationStartButtonProps {
  targets: CollaborationStartTarget[];
}

const START_HINT = 'Opens Edinshall Audit in SharePoint. Open the Finding there and request a supplier response.';

/**
 * Tracker #121 (owner option B): collaborations still start from the Finding
 * in SharePoint, where its current permissions and sharing policy are checked.
 * This button opens the customer's SharePoint app for the chosen installation;
 * the Portal does not list Findings itself.
 */
const CollaborationStartButton = ({ targets }: CollaborationStartButtonProps): JSX.Element => {
  const [selectedInstanceId, setSelectedInstanceId] = useState('');

  if (targets.length === 0) {
    return (
      <button
        className="btn"
        type="button"
        disabled
        title="No Edinshall Audit installation is registered for this tenant yet."
      >
        Start collaboration
      </button>
    );
  }

  const selected = targets.find((target) => target.instanceId === selectedInstanceId) ?? targets[0];

  return (
    <span className="collaboration-inline-actions">
      {targets.length > 1 && (
        <select
          className="input"
          aria-label="Edinshall Audit installation"
          value={selected.instanceId}
          onChange={(event) => setSelectedInstanceId(event.target.value)}
        >
          {targets.map((target) => (
            <option key={target.instanceId} value={target.instanceId}>
              {target.displayName}
            </option>
          ))}
        </select>
      )}
      <a className="btn" href={selected.appUrl} target="_blank" rel="noopener noreferrer" title={START_HINT}>
        Start collaboration
      </a>
    </span>
  );
};

export default CollaborationStartButton;
